export default "__VITE_ASSET__DaKoLxBw__"